<!-- eslint-disable vue/no-unused-vars -->
<template>
  <div>
    <b-card title="Ações">
      <b-row class="my-1 text-right mt-2 d-flex align-items-center">
        <b-col sm="12" md="6" class="d-flex">
          <b-form-group class="flex-grow-1">
            <b-form-input
              type="text"
              v-model="search"
              placeholder="Buscar item"
              @input="debounceSearch"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="6" class="d-flex justify-content-end">
          <b-button
            class="mb-1"
            variant="primary"
            @click="$router.push('/novo-projeto')"
            block
          >
            Novo Projeto +
          </b-button>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" md="6">
          <b-form-group>
            <label for="category" class="font-weight-bold text-primary"
              >Status:</label
            >
            <b-form-select
              v-model="statusOptionSelected"
              :options="statusOptions"
              value-field="value"
              text-field="name"
              placeholder="Selecione um status"
              @input="getAll"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group>
            <label for="category" class="font-weight-bold text-primary"
              >Tipo de projeto:</label
            >
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              placeholder="Selecione um projeto"
              v-model="project_type"
              :options="projectType"
              label="name"
              :searchable="true"
              :reduce="(option) => option.id"
              @input="getAll"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <b-card :title="`Projetos de: ${currentWorkspace.workspace_title}`">
      <b-row>
        <!-- Select à esquerda -->
        <b-col cols="12" md="4">
          <b-form-group
            label="Itens por página:"
            label-for="per-page-select"
            label-class="font-weight-bold text-primary"
            class="mb-0"
          >
            <b-form-select
              id="per-page-select"
              v-model="perPage"
              :options="[10, 20, 50, 100, 250, 1000]"
              @input="changePerPage"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Tabela principal  -->
      <b-table
        responsive="sm"
        small
        :items="items"
        :fields="fields"
        :sort-desc.sync="sortDesc"
        :per-page="perPage"
        :current-page="0"
        show-empty
        class="p-1 w-100 table-details"
      >
        <template #empty>
          <b-alert show variant="primary">
            <p class="text-center">
              <br />
              <strong>Não há dados para exibir</strong>
            </p>
            <hr />
          </b-alert>
        </template>
        <template v-slot:cell(project_code)="{ item }">
          {{ item.project_code }} <br />
          <small :style="{ color: 'red' }">{{
            item.is_archived ? '(Arquivado)' : ''
          }}</small>
        </template>
        <template v-slot:cell(created_at)="{ item }">
          {{
            item.created_at
              ? dateFormatter(item.created_at, 'dd/MM/yyyy')
              : 'indefinido'
          }}
        </template>
        <template v-slot:cell(actions)="{ item }">
          <Actions
            @openUnDeleteModal="openUnDeleteModal(item)"
            @openDeleteModal="openDeleteModal(item)"
            @openDeleteProjectModal="openDeleteProjectModal(item)"
            :item="item"
          />
        </template>
        <template v-slot:cell(finish_date)="{ item }">
          {{
            item.finish_date
              ? dateFormatter(item.finish_date, 'dd/MM/yyyy')
              : 'indefinido'
          }}
        </template>
        <template v-slot:cell(start_date)="{ item }">
          {{
            item.start_date
              ? dateFormatter(item.start_date, 'dd/MM/yyyy')
              : 'indefinido'
          }}
        </template>
        <template v-slot:cell(contract_date)="{ item }">
          {{
            item.contract_date
              ? dateFormatter(item.contract_date, 'dd/MM/yyyy')
              : 'indefinido'
          }}
        </template>
        <template
          v-slot:cell(stage_predicted_contract_revenue)="{ item, index }"
        >
          R$
          {{
            numberToMonetary(
              stages_data[index].stage_predicted_contract_revenue,
            )
          }}
        </template>
        <template v-slot:cell(totalExpenses)="{ item, index }">
          R$
          {{ numberToMonetary(stages_data[index].totalExpenses) }}
        </template>
        <template
          v-slot:cell(stage_predicted_direct_cost_revenue)="{ item, index }"
        >
          R$
          {{
            numberToMonetary(
              stages_data[index].stage_predicted_direct_cost_revenue,
            )
          }}
        </template>
        <template v-slot:cell(prevision_direct_cost)="{ item, index }">
          R$
          {{
            numberToMonetary(
              (stages_data[index].stage_predicted_direct_cost_revenue *
                item.direct_cost_prediction) /
                1000,
            )
          }}
        </template>
        <template v-slot:cell(alloc_indirect_cost)="{ item, index }">
          R$
          {{ numberToMonetary(sum_indirect_cost(item)) }}
        </template>
        <template v-slot:cell(project_type)="{ item, index }">
          {{
            item && item.project_type && item.project_type.name
              ? item.project_type.name
              : '-'
          }}
        </template>
        <template v-slot:cell(revenue_predicted)="{ item, index }">
          R$
          {{ numberToMonetary(stages_data[index].revenue_predicted) }}
        </template>

        <template v-slot:cell(revenue_realized)="{ item, index }">
          R$
          {{ numberToMonetary(stages_data[index].revenue_realized) }}
        </template>
      </b-table>
      <b-pagination
        class="justify-content-center"
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        @change="getPage"
        aria-controls="my-table"
      ></b-pagination>
      <div class="mr-2 d-flex justify-content-end">
        <strong>Total de projetos: {{ totalRows }} </strong>
      </div>
    </b-card>
    <b-modal
      v-model="deleteModal"
      title="Arquivar Projeto"
      hide-header-close
      hide-footer
    >
      <DeleteModal
        @closeDeleteModal="closeDeleteModal"
        :item="selectedItem"
        :exclusionType="exclusionType"
      />
    </b-modal>
    <b-modal
      v-model="unDeleteModal"
      title="Desarquivar Projeto"
      hide-header-close
      hide-footer
    >
      <UnDeleteModal
        @closeUnDeleteModal="closeUnDeleteModal"
        :item="selectedItem"
      />
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BModal,
  BRow,
  BButton,
  BTable,
  BCol,
  BFormInput,
  BFormGroup,
  BFormSelect,
  BAlert,
  BPagination,
} from 'bootstrap-vue';
import { VBTooltip } from 'bootstrap-vue';

import DeleteModal from './components/DeleteModal.vue';
import Actions from './components/ActionsProjects.vue';

import UnDeleteModal from './components/UnDeleteModal.vue';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BCard,
    BTable,
    BRow,
    BButton,
    Actions,
    BCol,
    BModal,
    BFormGroup,
    BFormInput,
    BFormSelect,
    DeleteModal,
    UnDeleteModal,
    BPagination,
    BAlert,
  },
  data: () => ({
    search: '',
    debounceTimer: null,
    projectType: [],
    project_type: '',
    exclusionType: '',
    sortDesc: false,
    fields: [
      {
        key: 'actions',
        label: 'Ações',
        sortable: false,
      },
      {
        key: 'project_code',
        label: 'Código',
        sortable: true,
      },
      {
        key: 'created_at',
        label: 'CRIADO EM',
        sortable: true,
      },
      {
        key: 'project_name',
        label: 'Nome do projeto',
        sortable: true,
      },
      {
        key: 'project_type',
        label: 'Tipo do projeto',
        sortable: true,
      },
      {
        key: 'client_name',
        label: 'Cliente',
        sortable: true,
      },
      {
        key: 'contact_name',
        label: 'Contato',
        sortable: true,
      },
      {
        key: 'finish_date',
        label: 'Prazo',
        sortable: true,
      },
      {
        key: 'contract_date',
        label: 'Data do contrato',
        sortable: true,
      },
      {
        key: 'start_date',
        label: 'Dia de início',
        sortable: true,
      },
      {
        key: 'stage_predicted_direct_cost_revenue',
        label: 'Receita planejada',
        sortable: true,
      },
      {
        key: 'prevision_direct_cost',
        label: 'Custo direto previsto',
        sortable: true,
      },
      // {
      //   key: 'stage_predicted_contract_revenue',
      //   label: 'Custo direto alocado',
      //   sortable: false,
      // },

      {
        key: 'alloc_indirect_cost',
        label: 'Custo indireto previsto',
        sortable: true,
      },
      {
        key: 'totalExpenses',
        label: 'Despesas acumuladas',
        sortable: true,
      },
      {
        key: 'revenue_predicted',
        label: 'Receita prevista',
        sortable: true,
      },
      {
        key: 'revenue_realized',
        label: 'Receita realizada',
        sortable: true,
      },
    ],
    deleteModal: false,
    unDeleteModal: false,
    items: [],
    selectedItem: null,
    showArchived: false,
    perPage: 100,
    currentPage: 1,
    totalRows: 0,
    statusOptions: [
      {
        value: 'todos',
        name: 'Todos',
      },
      {
        value: false,
        name: 'Em execução',
      },
      {
        value: true,
        name: 'Arquivado',
      },
    ],
    statusOptionSelected: false,
  }),

  created() {
    this.getAll();
    this.getAllProjectType();
  },

  computed: {
    currentWorkspace() {
      return this.$store.getters.currentWorkspace;
    },
  },

  methods: {
    async getPage(val) {
      this.currentPage = val;
      await this.getAll();
    },
    changePerPage() {
      this.page = 1;
      this.getAll();
    },
    sum_indirect_cost(val) {
      let administration_value = val?.administration_value || 0;
      let comission_value = val?.comission_value || 0;
      let retention_value = val?.retention_value || 0;
      let tax_value = val?.tax_value || 0;

      return (
        administration_value + comission_value + retention_value + tax_value
      );
    },
    debounceSearch() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.currentPage = 1;

        this.getAll();
      }, 500);
    },
    getAllProjectType() {
      this.items = [];
      let body = {
        inactive: false,
        workspace_id: this.$store.getters.currentWorkspace.id,
        page: 1,
        perPage: 1000,
      };
      this.$store
        .dispatch('getAllProjectType', body)
        .then((resp) => {
          if (resp) {
            this.projectType = resp.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getFilter() {
      this.items = [];
      let body = {
        id: this.$route.params.id,
        workspace_id: this.$store.getters.currentWorkspace.id,
        archived: this.statusOptionSelected,
        page: 1,
        perPage: this.perPage,
      };
      this.$store
        .dispatch('_getProjects', this.formatQueryParams(body))
        .then((resp) => {
          this.items = resp && resp.data ? resp.data : [];
          this.totalRows =
            resp && resp.pagination && resp.pagination.total
              ? resp.pagination.total
              : 0;

          if (resp && resp.data) {
            this.stages_data = resp.data.map((item) => {
              const stages = Array.isArray(item.project_stages)
                ? item.project_stages
                : [];

              // Soma receitas planejadas das etapas
              const totalContractRevenue = stages.reduce(
                (sum, stage) =>
                  sum + (stage.stage_predicted_contract_revenue || 0),
                0,
              );

              const totalDirectCostRevenue = stages.reduce(
                (sum, stage) =>
                  sum + (stage.stage_predicted_direct_cost_revenue || 0),
                0,
              );

              // DESPESAS
              const expenses = Array.isArray(item.expenses)
                ? item.expenses
                : [];

              const totalExpenses = expenses.reduce(
                (sum, expense) => sum + (expense.value || 0),
                0,
              );

              // RECEITAS
              const revenues = Array.isArray(item.revenues)
                ? item.revenues
                : [];

              const revenue_predicted = revenues.reduce((sum, revenue) => {
                if (revenue.status === 'previsto' && !revenue.deleted_at) {
                  return sum + (revenue.value || 0);
                }

                return sum;
              }, 0);

              const revenue_realized = revenues.reduce((sum, revenue) => {
                if (revenue.status === 'realizado' && !revenue.deleted_at) {
                  return sum + (revenue.value || 0);
                }

                return sum;
              }, 0);

              return {
                project_id: item.id,
                project_name: item.project_name,
                stage_predicted_contract_revenue: totalContractRevenue,
                stage_predicted_direct_cost_revenue: totalDirectCostRevenue,
                totalExpenses: totalExpenses,

                revenue_predicted,
                revenue_realized,
              };
            });
          }
          console.log('stage_predicted_contract_revenue', this.stages_data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getAll() {
      let body = {
        id: this.$route.params.id,
        page: this.currentPage,
        perPage: this.perPage,
        archived: this.statusOptionSelected,
        workspace_id: this.$store.getters.currentWorkspace.id,
        project_type: this.project_type,
        search: this.search ? this.search : null,
      };
      this.$store
        .dispatch('_getProjects', this.formatQueryParams(body))
        .then((resp) => {
          this.totalRows =
            resp && resp.pagination && resp.pagination.total
              ? resp.pagination.total
              : 0;
          this.items = resp && resp.data ? resp.data : [];

          if (resp && resp.data) {
            this.stages_data = resp.data.map((item) => {
              const stages = Array.isArray(item.project_stages)
                ? item.project_stages
                : [];

              // Soma receitas planejadas das etapas
              const totalContractRevenue = stages.reduce(
                (sum, stage) =>
                  sum + (stage.stage_predicted_contract_revenue || 0),
                0,
              );

              const totalDirectCostRevenue = stages.reduce(
                (sum, stage) =>
                  sum + (stage.stage_predicted_direct_cost_revenue || 0),
                0,
              );

              // DESPESAS
              const expenses = Array.isArray(item.expenses)
                ? item.expenses
                : [];

              const totalExpenses = expenses.reduce(
                (sum, expense) => sum + (expense.value || 0),
                0,
              );

              // RECEITAS
              const revenues = Array.isArray(item.revenues)
                ? item.revenues
                : [];

              const revenue_predicted = revenues.reduce((sum, revenue) => {
                if (revenue.status === 'previsto' && !revenue.deleted_at) {
                  return sum + (revenue.value || 0);
                }

                return sum;
              }, 0);

              const revenue_realized = revenues.reduce((sum, revenue) => {
                if (revenue.status === 'realizado' && !revenue.deleted_at) {
                  return sum + (revenue.value || 0);
                }

                return sum;
              }, 0);

              return {
                project_id: item.id,
                project_name: item.project_name,
                stage_predicted_contract_revenue: totalContractRevenue,
                stage_predicted_direct_cost_revenue: totalDirectCostRevenue,
                totalExpenses: totalExpenses,

                revenue_predicted,
                revenue_realized,
              };
            });
          }
          console.log('stage_predicted_contract_revenue', this.stages_data);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    closeDeleteModal() {
      this.deleteModal = false;
      this.getAll();
    },

    closeUnDeleteModal() {
      this.unDeleteModal = false;
      this.getAll();
    },

    openUnDeleteModal(item) {
      this.selectedItem = item;
      this.unDeleteModal = true;
    },

    openDeleteModal(item) {
      this.selectedItem = item;
      this.exclusionType = 'arquivar';
      this.deleteModal = true;
    },

    openDeleteProjectModal(item) {
      this.selectedItem = item;
      this.exclusionType = 'excluir';
      this.deleteModal = true;
    },

    filter() {
      if (this.search.trim() === '') {
        return this.items;
      } else {
        return this.items.filter((item) => {
          return (
            (item.project_code &&
              item.project_code
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) > -1) ||
            (item.project_name &&
              item.project_name
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) > -1) ||
            (item.client_name &&
              item.client_name
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) > -1) ||
            (item.contact_name &&
              item.contact_name
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) > -1)
          );
        });
      }
    },

    orderByName(array) {
      return array.sort((a, b) => {
        const nomeA = a.project_name.toUpperCase();
        const nomeB = b.project_name.toUpperCase();
        if (nomeA < nomeB) {
          return -1;
        }
        if (nomeA > nomeB) {
          return 1;
        }
        return 0;
      });
    },

    cleanFilter() {
      this.search = '';
    },
  },
};
</script>

<style>
.overflow-scroll-mobile {
  overflow-x: auto;
  white-space: nowrap;
}
.table-details {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
